var _path, _path2, _g, _path3, _g2, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBannerLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 141,
    viewBox: "0 0 234 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2708_26364)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2708_26364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 234,
    height: 141
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H234V141H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2708_26364)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2708_26364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: -9,
    width: 118,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.307 9.72788L120.084 -9L85.0003 121.818L167.224 140.546L202.307 9.72788Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2708_26364)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.941 14.3607C199.69 11.7852 198.405 9.92366 195.935 8.67281C195.951 8.56908 195.907 8.46289 195.771 8.40165C191.15 6.57838 185.946 7.4849 181.37 8.9473C176.731 10.4228 172.467 12.727 168.464 15.2833C164.722 17.6569 161.103 20.1987 157.6 22.8744C157.461 22.8812 157.327 22.9581 157.3 23.1032C152.748 26.5915 148.391 30.3029 144.221 34.148C144.162 34.2032 144.102 34.261 144.041 34.3189C144.016 34.269 143.977 34.2244 143.912 34.1875C140.304 32.485 136.271 32.1445 132.255 32.5234C128.668 32.8622 124.546 33.4097 121.731 35.6587C118.811 37.9663 116.831 41.4511 115.504 44.727C114.024 48.4634 113.466 52.4375 113.788 56.3641C113.811 56.6226 114.069 56.7173 114.256 56.6579C114.381 56.791 114.647 56.8241 114.795 56.6209C117.765 52.6102 120.893 48.5141 125.482 45.9785C125.506 46.0775 125.574 46.1675 125.718 46.2002C127.514 46.6367 129.274 47.2029 130.972 47.8924C131.172 47.982 131.354 47.872 131.426 47.726C131.453 47.7376 131.481 47.7467 131.509 47.7505C131.5 47.7647 131.486 47.7726 131.478 47.7901C128.157 54.823 129.252 63.2196 134.386 69.2607C134.633 69.5647 135.195 69.2523 134.948 68.9483C129.977 63.0819 128.791 54.9123 132.028 48.0805C132.142 47.8669 131.972 47.6742 131.783 47.6423C131.8 47.6267 131.818 47.6143 131.829 47.5948C131.905 47.4994 131.978 47.4085 132.053 47.3157C132.113 47.3045 132.175 47.2746 132.229 47.218C133.27 46.0432 134.331 44.8865 135.406 43.7388C135.348 49.1284 136.373 54.6081 139.871 59.06C140.119 59.3641 140.681 59.0517 140.433 58.7476C136.848 54.1988 135.916 48.5477 136.083 43.0204C141.528 37.2722 147.381 31.862 153.599 26.8183C154.825 25.8232 156.073 24.8248 157.333 23.8348C157.666 28.8788 159.3 33.7291 162.112 38.088C162.137 38.1268 162.166 38.1527 162.199 38.174C160.277 40.5517 158.926 43.3157 158.309 46.2498C158.286 46.371 158.326 46.4655 158.391 46.5354C158.395 46.4206 158.402 46.3065 158.415 46.1912C158.47 45.8955 158.876 45.9302 159.015 46.149C159.1 45.7748 159.202 45.4045 159.31 45.0355C159.356 45.0321 159.404 45.0184 159.453 44.9937C162.972 43.1255 166.499 41.2313 170.018 39.3631C170.369 39.1678 170.058 38.6565 169.679 38.8453C166.309 40.6348 162.934 42.4451 159.567 44.2351C159.911 43.2402 160.341 42.2728 160.85 41.3456C160.881 41.3416 160.916 41.3331 160.947 41.3155C166.589 38.5545 172.259 35.7998 177.907 33.0128C178.287 32.824 177.947 32.3064 177.568 32.4952C172.188 35.1286 166.782 37.7562 161.393 40.4124C162.528 38.5984 163.986 36.9514 165.721 35.5494C167.546 34.0935 169.661 32.8961 171.931 32.1195C174.433 31.2582 178.739 31.0278 178.925 34.4557C178.928 34.4894 178.924 34.5244 178.925 34.5575C176.739 35.5762 174.556 36.5955 172.363 37.6401C171.984 37.8289 172.33 38.3207 172.702 38.1579C174.759 37.1978 176.819 36.2357 178.881 35.2549C178.613 37.0572 177.259 38.7855 176.29 40.2687C175.043 42.1316 173.691 43.9429 172.071 45.528C170.408 47.1585 168.407 48.602 166.102 49.398C163.459 50.3375 158.624 49.9794 159.063 46.3361C159.071 46.2609 159.049 46.2007 159.015 46.1464C158.994 46.2378 158.969 46.3286 158.951 46.4206C158.896 46.7026 158.555 46.7048 158.392 46.5328C158.353 48.0241 159.257 49.3252 160.735 50.0198C162.616 50.9162 164.902 50.5285 166.743 49.7919C169.122 48.8557 171.113 47.3605 172.832 45.6079C177.127 47.544 181.88 48.0844 186.537 47.1468C183.742 51.5499 180.647 55.7911 177.29 59.8429C175.33 62.2124 173.281 64.5172 171.158 66.7613C171.033 66.8018 170.922 66.9031 170.907 67.0289C167.602 70.5039 164.113 73.8296 160.48 77.0124C160.474 77.0111 160.469 77.0098 160.462 77.0111C160.315 77.005 160.195 77.1154 160.16 77.2451C160.154 77.2685 160.146 77.2886 160.14 77.3093C159.844 77.5666 159.547 77.8266 159.248 78.0832C159.229 78.0788 159.212 78.0724 159.192 78.0704C156.16 78.1229 153.092 78.1949 150.065 77.7807C148.77 77.5958 147.467 77.3266 146.2 76.9278C145.55 76.7219 144.557 76.4106 143.656 75.9934C146.44 73.3356 147.898 69.4041 149.275 65.9194C149.943 64.6846 150.402 63.3549 150.119 61.9914C149.719 60.1387 148.218 59.2738 146.261 59.1035C144.628 58.9518 142.771 59.1893 141.882 60.6108C141.826 60.7412 141.86 60.859 141.93 60.9463C135.708 69.0004 129.484 77.0784 123.262 85.1323C123.122 85.3206 123.32 85.5858 123.559 85.5853C125.325 85.4646 126.835 84.7351 128.296 83.8568C130.15 82.7378 131.983 81.5864 133.795 80.4027C136.366 78.7038 138.89 76.9501 141.369 75.1368C141.728 75.5928 142.283 75.9531 142.879 76.2512C142.941 76.3204 143.032 76.3688 143.13 76.3718C143.616 76.5981 144.107 76.7869 144.522 76.9531C145.924 77.5202 147.396 77.9379 148.882 78.1937C152.275 78.8014 155.786 78.7479 159.212 78.6751C159.275 78.673 159.325 78.6541 159.37 78.6313C159.459 78.646 159.557 78.627 159.634 78.5509C159.843 78.3729 160.05 78.1916 160.256 78.0128C160.458 78.6424 160.856 79.2778 161.073 79.8697C161.52 81.1 161.848 82.3306 162.07 83.6198C162.075 83.6457 162.084 83.667 162.093 83.6884C159.611 87.9975 156.319 91.8029 152.346 95.0294C152.207 95.1465 152.224 95.293 152.313 95.3962C152.312 95.399 152.306 95.3999 152.305 95.4054C152.263 95.4506 152.221 95.4957 152.178 95.5418C152.122 95.6386 152.123 95.7492 152.186 95.8459C152.907 96.8357 154.946 96.1445 155.93 95.928C157.73 95.5676 159.459 95.0257 161.139 94.3346C164.66 92.9071 167.883 90.8063 170.499 88.182C173.481 85.2003 174.716 81.9311 174.401 77.8683C174.103 74.2307 173.513 70.4272 171.653 67.1769C177.904 60.605 183.509 53.5006 188.115 45.8988C191.853 39.7592 195.042 33.1089 197.512 26.4603C198.922 22.6527 200.351 18.4368 199.952 14.3548L199.941 14.3607ZM114.42 56.0897C113.926 49.2835 116.179 41.6301 121.478 36.702C124.187 34.1812 128.329 33.5558 132.022 33.1583C135.989 32.7408 140.008 33.0231 143.587 34.7191C143.593 34.7204 143.598 34.7217 143.604 34.723C142.818 35.4577 142.037 36.1991 141.266 36.9455C141.212 36.9443 141.155 36.9561 141.096 36.9867C136.201 39.75 131.308 42.5164 126.439 45.2854C126.415 45.0955 126.185 44.9165 125.937 45.0389C120.923 47.5438 117.564 51.8323 114.42 56.0897ZM137.244 40.2847C137.244 40.2847 137.24 40.2673 137.236 40.2582C137.512 39.9769 137.791 39.6937 138.07 39.4131C138.408 39.2231 138.743 39.0298 139.081 38.8398C139.12 38.8844 139.161 38.9322 139.199 38.9795C139.081 39.0984 138.965 39.2179 138.847 39.3341C138.313 39.653 137.78 39.9692 137.247 40.2854L137.244 40.2847ZM139.374 38.6725C139.476 38.616 139.578 38.5567 139.68 38.5001C139.59 38.5897 139.498 38.6787 139.407 38.771C139.402 38.7367 139.392 38.7043 139.376 38.6758L139.374 38.6725ZM133.881 79.6021C132.28 80.6686 130.658 81.7029 129.015 82.7048C127.526 83.6318 126.029 84.5763 124.251 84.8896C124.11 85.0695 123.971 85.2525 123.83 85.4324C123.724 85.2706 123.639 85.1412 123.533 84.9794C123.777 84.9607 124.016 84.9297 124.251 84.8896C130.473 76.8304 136.705 68.7485 142.928 60.6893C143.002 60.5907 142.993 60.4922 142.936 60.4158C144.063 59.4754 146.139 59.5134 147.492 59.9399C149.712 60.6326 149.786 62.7743 149.194 64.5249C149.156 64.5574 149.121 64.5989 149.097 64.6541C148.97 64.9694 148.843 65.2898 148.717 65.6135C147.192 68.525 144.946 71.1375 142.496 73.4446C142.442 73.4985 142.414 73.5582 142.408 73.6146C142.043 73.8863 141.682 74.162 141.314 74.4305C141.289 74.4442 141.267 74.461 141.247 74.4786C138.841 76.2398 136.389 77.9494 133.885 79.6002L133.881 79.6021ZM173.497 82.4323C173.003 84.274 171.861 85.858 170.549 87.2933C168.452 89.5406 165.862 91.4002 163.059 92.826C161.569 93.5881 160.002 94.1945 158.371 94.7032C157.654 94.9253 156.944 95.1216 156.185 95.2792C155.742 95.3704 155.299 95.4626 154.863 95.528C154.518 95.587 152.935 95.5842 152.872 95.7077C152.96 95.5907 152.935 95.4745 152.851 95.3953C156.91 92.0971 160.284 88.1507 162.784 83.7081C162.887 83.5498 162.79 83.3983 162.645 83.3268C162.578 82.951 162.502 82.5786 162.415 82.2094C162.559 82.2751 162.739 82.2611 162.826 82.0936C165.224 77.1626 168.045 72.438 171.261 67.9134C171.278 67.8842 171.288 67.8562 171.296 67.8278C172.823 70.6472 173.351 73.817 173.681 76.942C173.877 78.7756 173.974 80.6418 173.494 82.4317L173.497 82.4323ZM197.084 25.7931C195.921 29.0155 194.591 32.1806 193.11 35.2864C193.145 35.0991 193.059 34.8951 192.806 34.8373C192.271 34.7155 192.062 35.4937 192.597 35.6155C192.777 35.6566 192.919 35.5953 193.01 35.4921C191.66 38.306 190.187 41.0696 188.597 43.7765C188.542 43.6729 188.441 43.5896 188.315 43.5607C188.082 43.5353 187.843 43.6461 187.788 43.8535L187.767 43.9314C187.711 44.1389 187.86 44.3654 188.085 44.4167C188.124 44.4257 188.166 44.4269 188.208 44.4254C187.748 45.1958 187.278 45.9643 186.8 46.7249C186.737 46.6117 186.606 46.5322 186.431 46.5722C185.515 46.7571 184.594 46.8804 183.677 46.9468C183.735 46.7509 183.657 46.5184 183.384 46.4562C182.987 46.3657 182.767 46.7285 182.869 46.994C179.57 47.1151 176.298 46.4909 173.261 45.1551C174.407 43.927 175.425 42.5928 176.353 41.2491C178.062 38.7759 181.735 33.9974 177.886 31.6344C175.741 30.3038 172.979 30.817 170.493 31.8967C170.543 31.6905 170.396 31.4698 170.173 31.4192C169.951 31.3685 169.709 31.4786 169.646 31.712L169.626 31.7898C169.582 31.9506 169.662 32.1203 169.802 32.2126C169.132 32.5363 168.49 32.891 167.893 33.2559C167.939 33.0627 167.857 32.8458 167.595 32.7861C167.032 32.6578 166.823 33.436 167.386 33.5643C167.392 33.5656 167.395 33.5662 167.398 33.5669C166.882 33.898 166.407 34.2302 165.989 34.5397C164.736 35.4681 163.604 36.5233 162.608 37.6753C161.376 35.7488 160.375 33.7207 159.623 31.6226C159.839 31.4297 159.833 31.0182 159.456 30.9322C159.43 30.9265 159.407 30.9239 159.387 30.922C158.577 28.4696 158.096 25.927 157.966 23.3376C159.292 22.3047 160.64 21.2795 162.011 20.2789C162.069 20.3637 162.159 20.4283 162.269 20.4533L162.353 20.4725C162.579 20.5238 162.825 20.3872 162.88 20.1796C162.922 20.0241 162.864 19.8596 162.726 19.7646C167.412 16.3869 172.363 13.2924 177.656 10.9942C182.858 8.7468 189.515 6.75912 195.118 8.81147C195.13 8.88856 195.179 8.96037 195.281 9.0055C197.076 9.84382 198.171 11.0538 198.785 12.4762C198.265 12.377 198.064 13.1351 198.594 13.2557C198.785 13.2993 198.936 13.2264 199.024 13.1115C200.278 17.0164 198.355 22.2263 197.084 25.7931Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.08 57.4485C140.691 53.8767 139.053 49.9532 138.189 45.8204C138.104 45.4707 137.464 45.6277 137.543 46.0033C138.421 50.1945 140.079 54.1503 142.518 57.7609C142.73 58.0845 143.292 57.7721 143.08 57.4485Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.443 67.5479C150.603 67.1716 150.025 66.8749 149.865 67.2511C149.536 67.9195 150.276 68.2806 150.812 68.6229C152.285 69.5915 153.878 70.4497 155.513 71.1523C156.957 71.7841 158.436 72.2861 159.971 72.6909C161.338 73.057 163.035 73.6363 164.462 73.3284C164.877 73.2303 164.671 72.6604 164.285 72.765C163.04 73.0595 161.35 72.4543 160.153 72.1266C158.927 71.7924 157.744 71.4128 156.56 70.923C155.94 70.6717 150.17 68.1189 150.443 67.5479Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.637 68.2357C158.886 69.7186 162.239 70.9228 165.703 71.8219C166.091 71.9377 166.251 71.3411 165.863 71.2253C162.427 70.3326 159.13 69.1413 155.966 67.6776C155.579 67.5618 155.264 68.068 155.637 68.2357Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.372 27.3301C155.372 27.3301 155.363 27.3279 155.361 27.3242C155.361 27.3242 155.363 27.3279 155.372 27.3301Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.971 27.596C155.01 27.594 155.051 27.5867 155.093 27.5744C154.897 27.4277 154.813 27.1609 154.924 26.9357C154.837 27.015 154.77 27.1182 154.738 27.2375C154.697 27.3931 154.803 27.5549 154.972 27.5935L154.971 27.596Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.364 26.7552C155.227 26.7076 155.06 26.73 154.955 26.8767C154.941 26.8955 154.934 26.9189 154.923 26.9383C155.038 26.8324 155.194 26.766 155.364 26.7552Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.533 27.1734C155.491 27.2189 155.54 27.1475 155.518 27.1152C155.497 27.0828 155.469 27.0764 155.441 27.07C155.413 27.0635 155.378 27.0831 155.364 27.135C155.393 27.2049 155.409 27.2554 155.435 27.3053C155.429 27.304 155.426 27.3033 155.435 27.3162C155.437 27.3169 155.437 27.3169 155.437 27.3169C155.437 27.3169 155.439 27.3227 155.442 27.3233C155.449 27.3304 155.449 27.3278 155.442 27.3233C155.445 27.3325 155.449 27.3389 155.453 27.3479C155.411 27.3053 155.429 27.3149 155.442 27.3233C155.442 27.3233 155.436 27.322 155.435 27.3162L155.406 27.3098C155.406 27.3098 155.386 27.3079 155.379 27.3118C155.385 27.3131 155.388 27.3222 155.374 27.33C155.364 27.4571 155.238 27.5383 155.096 27.575C155.143 27.6105 155.195 27.6415 155.256 27.6608C155.587 27.7638 155.938 27.5685 155.993 27.2508C156.055 26.9072 155.689 26.7136 155.379 26.7532C155.377 26.7525 155.37 26.7539 155.367 26.7558C155.536 26.8164 155.651 26.9884 155.535 27.174L155.533 27.1734Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.363 27.3267C155.363 27.3267 155.365 27.3203 155.366 27.3171C155.363 27.3164 155.361 27.3227 155.363 27.3267Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.906 31.2413C155.906 31.2413 155.924 31.2537 155.933 31.2557C155.933 31.2557 155.933 31.2557 155.933 31.2531C155.925 31.2485 155.917 31.2439 155.907 31.2386L155.906 31.2413Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.913 31.2155C155.913 31.2155 155.911 31.2214 155.911 31.2244L155.918 31.2199C155.918 31.2199 155.919 31.217 155.92 31.214C155.92 31.214 155.917 31.2133 155.913 31.2155Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.866 31.2161C155.866 31.2161 155.86 31.2146 155.855 31.2102C155.858 31.2109 155.861 31.2117 155.863 31.2153L155.866 31.2161Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.265 31.5162C155.484 31.8138 155.934 31.9164 156.257 31.7148C156.644 31.5 156.628 31.0011 156.339 30.7425C156.049 30.484 155.529 30.5305 155.347 30.8744C155.293 30.975 155.274 31.0807 155.276 31.1831C155.404 31.0415 155.678 30.9994 155.826 31.2038L155.869 31.2135C155.869 31.2135 155.901 31.1933 155.918 31.1972C155.918 31.1972 155.917 31.1997 155.917 31.2023C155.919 31.1945 155.922 31.2036 155.923 31.212C155.933 31.2088 155.943 31.2055 155.943 31.2055L155.921 31.2172C155.921 31.2172 155.917 31.2327 155.918 31.2192C155.918 31.2192 155.916 31.2269 155.917 31.2327C155.927 31.2405 155.931 31.2496 155.929 31.2548C156.048 31.3258 156.121 31.4306 156.098 31.5162C156.064 31.6459 155.874 31.7954 155.712 31.7309C155.438 31.6493 155.279 31.4287 155.273 31.185C155.196 31.2721 155.169 31.3926 155.261 31.5181L155.265 31.5162Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.914 31.2156C155.893 31.2252 155.872 31.2321 155.912 31.2238L155.914 31.2156Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.922 31.219L155.925 31.2198C155.925 31.2198 155.926 31.2134 155.927 31.2102C155.927 31.2102 155.924 31.2094 155.92 31.2118C155.92 31.2118 155.919 31.215 155.918 31.2182L155.922 31.219Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.919 31.2156C155.92 31.2126 155.921 31.2096 155.919 31.203C155.919 31.2059 155.918 31.2089 155.919 31.2156Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.887 31.2258C155.887 31.2258 155.897 31.2199 155.886 31.2173L155.872 31.2141C155.872 31.2141 155.872 31.2141 155.868 31.216C155.877 31.218 155.881 31.2245 155.889 31.2265L155.887 31.2258Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.911 31.2231C155.911 31.2231 155.892 31.2271 155.886 31.2284C155.894 31.2303 155.898 31.2369 155.907 31.2389L155.911 31.2231Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.904 31.249C155.954 31.2885 155.868 31.2689 155.904 31.249Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.889 31.229C155.881 31.2245 155.876 31.2205 155.868 31.216C155.868 31.216 155.871 31.2167 155.873 31.2199C155.876 31.2205 155.886 31.2284 155.914 31.2487C155.907 31.2389 155.91 31.2395 155.915 31.2434C155.915 31.2434 155.903 31.2323 155.895 31.2277L155.889 31.229Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.921 31.2313C155.921 31.2313 155.917 31.2244 155.911 31.2231C155.918 31.2538 155.921 31.2456 155.921 31.2313Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.905 31.2438L155.904 31.2491C155.939 31.2767 155.915 31.2517 155.905 31.2438Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.086 35.9282L157.076 35.9196C157.013 35.9255 157.058 35.9304 157.086 35.9282Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.023 35.8802L157.016 35.9065L157.044 35.9131C157.044 35.9131 157.027 35.898 157.024 35.8973C157.022 35.8967 157.019 35.896 157.023 35.8802Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.58 36.3649C157.845 36.0811 157.708 35.6427 157.381 35.4581C157.417 35.6012 157.319 35.7576 157.163 35.802C157.072 35.8088 157.1 35.8152 157.065 35.8347C157.086 35.823 157.071 35.8359 157.061 35.8477C157.053 35.8677 157.034 35.8937 157.027 35.8977C157.027 35.8977 157.055 35.9151 157.075 35.9195L157.131 35.9324C157.216 35.9516 157.258 35.9062 157.272 35.8543C157.293 35.8866 157.279 35.8284 157.251 35.8219C157.617 36.0156 157.295 36.5477 156.865 36.3672C156.626 36.2577 156.534 36.0439 156.568 35.8041C156.631 35.5706 156.806 35.3628 157.073 35.3687C157.189 35.3704 157.293 35.4077 157.384 35.4587C157.382 35.4529 157.385 35.4451 157.383 35.4393C157.34 35.2644 157.15 35.1935 156.989 35.2393C156.517 35.3247 156.223 35.8632 156.478 36.2515C156.711 36.6074 157.295 36.6579 157.583 36.3656L157.58 36.3649Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.016 35.9062L156.988 35.8997C157.002 35.959 157.016 35.9062 157.016 35.9062Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.1 35.9477L157.129 35.9319C157.129 35.9319 157.104 35.9458 157.098 35.9445L157.1 35.9477Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.099 35.9453C157.099 35.9453 157.101 35.9398 157.103 35.9289C157.101 35.9281 157.094 35.9295 157.084 35.9302C157.092 35.935 157.097 35.9419 157.101 35.9487L157.099 35.9453Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.062 35.8459C157.062 35.8459 157.065 35.8377 157.066 35.8322C157.048 35.8542 157.052 35.8493 157.062 35.8459Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.094 35.9514C157.151 35.9643 157.051 35.9976 157.094 35.9514Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.398 48.2312L172.393 48.2163C172.429 48.1968 172.358 48.2358 172.33 48.2295C172.365 48.2098 172.266 48.2426 172.266 48.2426L172.097 48.204C172.157 48.2948 172.199 48.3597 172.256 48.4472C172.262 48.4485 172.266 48.444 172.27 48.4421C172.277 48.3497 172.326 48.2561 172.398 48.2338V48.2312Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.226 48.8386C172.43 48.8576 172.655 48.7987 172.809 48.6688C173.146 48.4153 173.117 47.9681 172.722 47.7681C172.709 47.7623 172.694 47.7618 172.684 47.754C172.716 47.7999 172.738 47.8517 172.743 47.9107C172.755 48.0454 172.658 48.1526 172.523 48.199C172.493 48.3325 172.387 48.4157 172.269 48.4413C172.267 48.4491 172.266 48.4543 172.264 48.462C172.26 48.4555 172.258 48.4523 172.253 48.4459C172.07 48.4813 171.872 48.3865 171.897 48.1582C171.888 47.7572 172.337 47.62 172.681 47.7533C172.621 47.6654 172.524 47.6047 172.402 47.6127C171.945 47.6462 171.545 48.0231 171.603 48.4766C171.646 48.7616 171.955 48.8322 172.223 48.838L172.226 48.8386Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.408 48.3026L172.429 48.3071L172.418 48.2907C172.418 48.2907 172.407 48.2966 172.4 48.3006L172.408 48.3026Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.418 48.2914C172.464 48.2659 172.504 48.239 172.524 48.1992C172.49 48.211 172.458 48.2202 172.421 48.2228C172.412 48.2209 172.404 48.2301 172.397 48.2314C172.4 48.2458 172.405 48.2608 172.407 48.2751L172.418 48.2914Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.124 49.8966C177.124 49.8966 177.129 49.9006 177.14 49.9032C177.147 49.8992 177.153 49.9005 177.16 49.8992C177.151 49.8973 177.142 49.8953 177.137 49.8914C177.137 49.8914 177.137 49.894 177.136 49.8966C177.136 49.8966 177.13 49.8953 177.124 49.8966Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.197 49.8062C177.175 49.7727 177.168 49.7996 177.197 49.8062Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.112 49.8967C177.112 49.8967 177.118 49.8982 177.125 49.8967C177.122 49.896 177.122 49.896 177.114 49.9004L177.112 49.8967Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.803 50.3355C176.739 50.2383 176.738 50.1003 176.782 50.0114C176.861 49.8946 177.004 49.8527 177.138 49.8888C177.139 49.8862 177.139 49.8835 177.148 49.8745C177.197 49.8031 177.106 49.9199 177.155 49.8485C177.155 49.8485 177.211 49.7512 177.162 49.8226C177.166 49.807 177.169 49.7966 177.165 49.7876C177.165 49.7876 177.164 49.7902 177.169 49.7966L177.176 49.7707C177.204 49.7772 177.197 49.8031 177.197 49.8031C177.19 49.829 177.218 49.8354 177.218 49.8354L177.274 49.8482C177.253 49.8599 177.247 49.8613 177.244 49.8607C177.243 49.8632 177.243 49.8632 177.239 49.8678L177.225 49.9196C177.31 50.049 177.255 50.2566 177.142 50.3411C177.019 50.4095 176.9 50.3961 176.803 50.3355C176.828 50.3743 176.864 50.4098 176.91 50.4259C177.234 50.5548 177.558 50.4633 177.754 50.1777C177.908 49.9375 177.935 49.6134 177.716 49.426C177.187 48.9476 176.24 49.6952 176.692 50.2385C176.725 50.2792 176.762 50.3096 176.803 50.3355Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.225 49.9225C177.196 49.9153 177.189 49.9444 177.225 49.9225Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.225 49.9223C177.189 49.9421 177.182 49.9683 177.225 49.9223Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.162 49.8998C177.185 49.9051 177.208 49.9103 177.229 49.9234C177.211 49.8971 177.188 49.8919 177.162 49.8998Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.228 50.4343L182.229 50.4291C182.229 50.4291 182.205 50.4292 182.192 50.4318C182.199 50.4416 182.205 50.4515 182.222 50.4553L182.228 50.4343Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.138 50.4358C182.124 50.4326 182.115 50.4307 182.108 50.4235C182.099 50.4242 182.101 50.4274 182.138 50.4358Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.229 50.4295C182.301 50.3898 182.136 50.4363 182.229 50.4295Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.138 50.436C182.155 50.4399 182.174 50.4359 182.193 50.432C182.189 50.4255 182.185 50.419 182.173 50.4164C182.168 50.4125 182.168 50.4124 182.166 50.4092C182.165 50.4118 182.165 50.4145 182.145 50.4099L182.088 50.397C182.117 50.4035 182.11 50.4296 182.088 50.397C182.099 50.4133 182.103 50.4198 182.108 50.4237C182.126 50.4224 182.2 50.4307 182.138 50.436Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.124 50.3775C182.124 50.3775 182.102 50.3808 182.085 50.3881C182.085 50.3881 182.086 50.394 182.088 50.3973L182.124 50.3775Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.034 50.2885C182.034 50.2885 182.023 50.2747 182.016 50.2675C182.013 50.2669 182.007 50.2656 182.004 50.265C181.966 50.273 181.995 50.2768 182.035 50.2859L182.034 50.2885Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.109 50.3192C182.09 50.3037 182.059 50.294 182.034 50.2882C182.051 50.3116 182.066 50.3369 182.078 50.3675C182.093 50.3571 182.102 50.3453 182.109 50.3192Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.484 50.3776C181.563 50.1921 181.865 50.1149 182.015 50.2674C182.193 50.2613 182.329 50.3996 182.378 50.5427C182.392 50.7112 182.238 50.8411 182.055 50.8546C181.731 50.8825 181.515 50.6381 181.484 50.375C181.461 50.4275 181.454 50.4892 181.477 50.5578C181.584 50.9399 182.077 51.1073 182.442 50.9703C182.871 50.8202 183.025 50.3598 182.749 50.0493C182.615 49.8811 182.432 49.7844 182.228 49.7654C182.115 49.7398 182.024 49.7464 181.925 49.779C181.925 49.779 181.756 49.8507 181.82 49.8376C181.749 49.8767 181.714 49.8961 181.644 49.9352C181.511 50.0509 181.464 50.2163 181.484 50.375V50.3776Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.088 50.3887C182.088 50.3887 182.083 50.3737 182.078 50.3672C182.064 50.3777 182.046 50.3874 182.025 50.4103C181.967 50.458 182.036 50.4129 182.085 50.3881L182.088 50.3887Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.821 77.865C162.821 77.865 162.819 77.8729 162.816 77.8749C162.821 77.8677 162.825 77.8631 162.83 77.8559C162.829 77.8585 162.825 77.8631 162.821 77.865Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.195 77.2756C162.945 77.5931 162.712 77.9144 162.49 78.252C162.6 78.1228 162.709 77.9935 162.818 77.8669C162.945 77.6728 163.069 77.4755 163.191 77.2775L163.195 77.2756Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.827 77.8553C162.936 77.726 163.049 77.5948 163.159 77.4656C163.193 77.4046 163.224 77.343 163.259 77.282C163.12 77.476 162.976 77.6662 162.827 77.8553Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.598 76.7867C163.563 76.8282 163.527 76.8724 163.492 76.914C163.414 77.0366 163.334 77.1586 163.261 77.2826C163.377 77.119 163.491 76.9522 163.601 76.7873L163.598 76.7867Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.757 79.0709C161.757 79.0709 161.768 79.0762 161.77 79.0794C161.773 79.0662 161.78 79.0537 161.783 79.0405C161.775 79.0497 161.765 79.0616 161.754 79.0703L161.757 79.0709Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.492 76.914C163.574 76.7867 163.653 76.6589 163.74 76.5329C163.811 76.4031 163.882 76.2734 163.952 76.1436C163.871 76.2351 163.793 76.3274 163.714 76.4195C163.547 76.7064 163.375 76.992 163.197 77.2762C163.293 77.1548 163.394 77.0347 163.495 76.9146L163.492 76.914Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.354 77.2376C163.499 77.0643 163.649 76.8948 163.795 76.7213C163.764 76.7007 163.737 76.6807 163.706 76.66C163.671 76.7015 163.64 76.7412 163.605 76.7827C163.522 76.9346 163.439 77.0891 163.356 77.2408L163.354 77.2376Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.605 76.7803C163.605 76.7803 163.608 76.7724 163.608 76.7698C163.606 76.7777 163.599 76.7816 163.597 76.7895C163.598 76.7869 163.601 76.7849 163.605 76.7803Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.158 77.4682C162.935 77.8634 162.733 78.2715 162.56 78.6944C162.825 78.2097 163.089 77.7249 163.354 77.2376C163.289 77.3136 163.224 77.3896 163.158 77.4682Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.009 61.2704C119.698 64.1344 115.002 67.8265 111.11 72.1972C110.851 72.4959 111.31 72.9031 111.569 72.6043C115.454 68.2596 120.079 64.6066 125.355 61.7622C125.699 61.5928 125.36 61.0751 125.009 61.2704Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.862 91.7191C114.661 85.1881 120.589 79.4646 127.421 74.7177C127.751 74.4901 127.412 73.9724 127.082 74.1999C120.145 79.0056 114.132 84.8199 109.284 91.4222C109.045 91.7533 109.63 92.0242 109.862 91.7191Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5454 107.377C96.6437 95.5068 105.567 84.6306 116.043 75.0988C116.331 74.8064 115.851 74.3669 115.563 74.6592C105.053 84.2106 96.0797 95.1585 88.9675 107.08C88.7574 107.417 89.3353 107.715 89.5454 107.377Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.468 89.0786C110.34 99.6529 101.418 111.19 93.8565 123.451C93.6465 123.788 94.2243 124.085 94.4344 123.747C101.982 111.539 110.89 100.054 120.947 89.5182C121.214 89.1935 120.755 88.7863 120.468 89.0786Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.546 80.5498C132.94 86.9016 125.18 94.1069 118.33 102.043C118.07 102.341 118.522 102.774 118.788 102.45C125.638 94.5143 133.433 87.2893 142.005 80.957C142.335 80.7294 141.876 80.3222 141.546 80.5498Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.683 27.0253C160.457 26.974 160.211 27.1106 160.156 27.3182L160.135 27.396C160.079 27.6035 160.228 27.83 160.453 27.8812C160.678 27.9326 160.917 27.8219 160.98 27.5885L161.001 27.5106C161.056 27.3031 160.908 27.0766 160.683 27.0253Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.184 25.7233C162.62 25.595 162.412 26.3732 162.975 26.5015C163.538 26.6298 163.719 25.8451 163.184 25.7233Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.762 24.3563C165.536 24.305 165.291 24.4417 165.235 24.6491L165.214 24.727C165.158 24.9345 165.307 25.161 165.532 25.2123C165.764 25.2376 166.003 25.127 166.059 24.9194L166.08 24.8416C166.135 24.6341 165.987 24.4076 165.762 24.3563Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.178 22.9249C167.643 22.803 167.434 23.5811 167.969 23.703C168.504 23.825 168.713 23.0467 168.178 22.9249Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.135 24.8838C158.6 24.7618 158.363 25.5337 158.926 25.6619C159.49 25.7902 159.67 25.0057 159.135 24.8838Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.016 23.6133C161.889 23.4191 161.635 23.3614 161.425 23.4786C161.214 23.5957 161.151 23.8291 161.279 24.0233L161.342 24.1203C161.469 24.3145 161.723 24.3722 161.934 24.2551C162.109 24.1575 162.179 23.8981 162.08 23.7103C162.059 23.678 162.037 23.6456 162.016 23.6133Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.044 21.9559C164.009 21.9754 163.974 21.9949 163.939 22.0145C163.728 22.1316 163.666 22.3651 163.793 22.5592C163.92 22.7534 164.174 22.8111 164.384 22.6939L164.49 22.6353C164.701 22.5182 164.763 22.2848 164.636 22.0906C164.509 21.8965 164.255 21.8387 164.044 21.9559Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.209 21.0176L166.188 21.0955C166.132 21.3029 166.281 21.5294 166.506 21.5808C166.731 21.6321 166.977 21.4954 167.033 21.2879L167.054 21.2101C167.109 21.0026 166.961 20.7761 166.736 20.7247C166.51 20.6734 166.264 20.8101 166.209 21.0176Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.07 19.1344C165.133 19.1212 165.197 19.1081 165.26 19.095C165.485 19.0361 165.611 18.7896 165.547 18.5823C165.483 18.3751 165.243 18.2655 164.99 18.3179C164.927 18.331 164.864 18.3441 164.8 18.3573C164.575 18.4161 164.45 18.6627 164.513 18.87C164.606 19.0836 164.845 19.1932 165.07 19.1344Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.374 17.6773C167.909 17.7992 168.117 17.0209 167.582 16.8991C167.047 16.7772 166.838 17.5554 167.374 17.6773Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.959 16.5047L170.065 16.446C170.275 16.3289 170.338 16.0955 170.211 15.9013C170.084 15.7072 169.83 15.6494 169.619 15.7667C169.584 15.7861 169.549 15.8057 169.514 15.8252C169.303 15.9423 169.241 16.1758 169.368 16.3699C169.467 16.5577 169.749 16.6218 169.959 16.5047Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.473 14.9305L172.558 14.9497C172.783 15.001 173.029 14.8643 173.085 14.6568C173.112 14.4429 172.992 14.2228 172.767 14.1714L172.682 14.1523C172.457 14.1009 172.211 14.2376 172.155 14.4452C172.1 14.6526 172.248 14.8791 172.473 14.9305Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.932 13.6739L175.017 13.6932C175.242 13.7445 175.488 13.6077 175.544 13.4003C175.599 13.1927 175.451 12.9662 175.225 12.915L175.141 12.8957C174.916 12.8444 174.67 12.9811 174.614 13.1886C174.559 13.396 174.707 13.6226 174.932 13.6739Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.236 12.3269C177.468 12.3524 177.707 12.2416 177.763 12.0341L177.784 11.9563C177.839 11.7487 177.691 11.5223 177.466 11.471C177.24 11.4196 176.994 11.5563 176.939 11.7638L176.918 11.8416C176.862 12.0492 177.011 12.2756 177.236 12.3269Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.662 9.91457C180.437 9.86325 180.191 9.99992 180.135 10.2074L180.115 10.2853C180.059 10.4927 180.207 10.7193 180.433 10.7706C180.665 10.7959 180.904 10.6852 180.96 10.4777L180.98 10.3999C181.036 10.1924 180.888 9.96589 180.662 9.91457Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.391 10.3937C186.926 10.5156 187.135 9.7374 186.6 9.61552C186.037 9.48722 185.828 10.2654 186.391 10.3937Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.244 9.00665C189.779 9.12853 189.987 8.35034 189.452 8.22845C188.917 8.10658 188.709 8.88476 189.244 9.00665Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.601 11.1875C191.136 11.3094 191.345 10.5313 190.81 10.4093C190.275 10.2874 190.066 11.0657 190.601 11.1875Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.954 9.76918C193.489 9.89107 193.698 9.11289 193.163 8.991C192.628 8.86911 192.391 9.64089 192.954 9.76918Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.86 11.9099C195.396 12.0317 195.604 11.2536 195.069 11.1316C194.534 11.0098 194.325 11.788 194.86 11.9099Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.134 14.1817C196.359 14.233 196.605 14.0963 196.661 13.8888L196.682 13.811C196.737 13.6035 196.589 13.377 196.364 13.3257C196.11 13.2679 195.899 13.3851 195.837 13.6185L195.816 13.6964C195.76 13.9039 195.909 14.1303 196.134 14.1817Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.292 15.719C197.728 15.5907 197.52 16.3689 198.083 16.4972C198.646 16.6256 198.827 15.841 198.292 15.719Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.857 20.4015C197.392 20.5235 197.6 19.7453 197.065 19.6234C196.502 19.4951 196.293 20.2732 196.857 20.4015Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.961 17.6105C195.834 17.4163 195.581 17.3586 195.37 17.4757C195.159 17.5929 195.097 17.8263 195.224 18.0205C195.245 18.0528 195.266 18.0852 195.288 18.1175C195.415 18.3116 195.668 18.3694 195.879 18.2522C196.09 18.135 196.159 17.8757 196.025 17.7075L195.961 17.6105Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.246 23.3453C195.683 23.217 195.474 23.9952 196.038 24.1235C196.601 24.2518 196.782 23.4672 196.246 23.3453Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.459 20.984C193.924 20.8621 193.715 21.6403 194.25 21.7621C194.786 21.8841 194.994 21.1059 194.459 20.984Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.218 24.83C193.183 24.8496 193.148 24.869 193.113 24.8886C192.902 25.0057 192.84 25.2392 192.967 25.4333C193.094 25.6275 193.348 25.6852 193.558 25.568L193.664 25.5094C193.874 25.3923 193.937 25.1589 193.81 24.9648C193.683 24.7706 193.429 24.7129 193.218 24.83Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.146 27.1132C194.921 27.0619 194.675 27.1986 194.619 27.4061L194.599 27.484C194.543 27.6914 194.691 27.9179 194.917 27.9693C195.142 28.0206 195.388 27.8839 195.444 27.6764L195.464 27.5985C195.52 27.3911 195.372 27.1645 195.146 27.1132Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.374 29.4269C192.909 29.5488 193.118 28.7706 192.583 28.6488C192.048 28.5268 191.839 29.305 192.374 29.4269Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.941 30.9398C193.715 30.8884 193.477 30.9991 193.414 31.2326L193.393 31.3104C193.337 31.5179 193.486 31.7445 193.711 31.7957C193.937 31.847 194.182 31.7104 194.238 31.5028L194.259 31.4251C194.315 31.2175 194.166 30.9911 193.941 30.9398Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.779 32.5391C191.651 32.345 191.398 32.2872 191.187 32.4043C190.983 32.4956 190.914 32.755 191.041 32.9491C191.062 32.9814 191.083 33.0138 191.105 33.0461C191.232 33.2403 191.485 33.298 191.696 33.1808C191.907 33.0637 191.969 32.8303 191.842 32.6361L191.779 32.5391Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.504 33.9401L188.462 34.0957C188.407 34.3033 188.555 34.5297 188.78 34.581C189.006 34.6324 189.251 34.4957 189.307 34.2882L189.349 34.1325C189.405 33.9251 189.256 33.6986 189.031 33.6472C188.798 33.6219 188.56 33.7326 188.504 33.9401Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.991 37.0863C190.223 37.1117 190.462 37.0009 190.518 36.7935L190.56 36.6378C190.615 36.4303 190.467 36.2038 190.242 36.1525C190.016 36.1012 189.77 36.2379 189.715 36.4453L189.673 36.601C189.617 36.8085 189.766 37.035 189.991 37.0863Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.185 37.8034C187.65 37.6815 187.441 38.4598 187.976 38.5816C188.512 38.7035 188.72 37.9253 188.185 37.8034Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.289 39.9265C188.754 39.8047 188.545 40.5829 189.081 40.7047C189.616 40.8266 189.824 40.0485 189.289 39.9265Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.446 35.0402C186.22 34.9889 185.982 35.0996 185.919 35.3331L185.898 35.4108C185.842 35.6184 185.991 35.8449 186.216 35.8961C186.441 35.9475 186.687 35.8108 186.743 35.6033L186.764 35.5255C186.819 35.3179 186.671 35.0915 186.446 35.0402Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.504 31.4279C186.941 31.2996 186.732 32.0778 187.295 32.2061C187.859 32.3344 188.039 31.5498 187.504 31.4279Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.409 30.8985C189.944 31.0204 190.153 30.2421 189.618 30.1203C189.083 29.9984 188.874 30.7766 189.409 30.8985Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.66 33.3399C185.195 33.4618 185.404 32.6835 184.869 32.5617C184.334 32.4398 184.125 33.218 184.66 33.3399Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.207 34.24C181.672 34.1181 181.464 34.8963 181.999 35.0182C182.534 35.1401 182.743 34.3619 182.207 34.24Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.522 32.9478C181.057 33.0697 181.266 32.2914 180.731 32.1696C180.167 32.0413 179.959 32.8195 180.522 32.9478Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.54 30.6076L183.456 30.5884C183.23 30.537 182.985 30.6737 182.929 30.8812C182.873 31.0888 183.022 31.3152 183.247 31.3665L183.332 31.3858C183.557 31.4371 183.803 31.3005 183.858 31.0929C183.914 30.8854 183.766 30.659 183.54 30.6076Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.572 29.9418C186.107 30.0637 186.315 29.2855 185.78 29.1636C185.245 29.0417 185.037 29.82 185.572 29.9418Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.437 28.2825L188.458 28.2047C188.514 27.9972 188.365 27.7707 188.14 27.7193C187.915 27.668 187.669 27.8048 187.613 28.0122L187.592 28.0901C187.537 28.2975 187.685 28.524 187.91 28.5754C188.136 28.6267 188.375 28.5159 188.437 28.2825Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.573 27.2276C191.108 27.3495 191.317 26.5713 190.782 26.4494C190.247 26.3276 190.038 27.1058 190.573 27.2276Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.734 25.9404C187.27 26.0624 187.478 25.2841 186.943 25.1623C186.408 25.0403 186.199 25.8185 186.734 25.9404Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.151 24.6192C189.686 24.741 189.895 23.9628 189.36 23.841C188.796 23.7127 188.588 24.4909 189.151 24.6192Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.86 22.4288C191.325 22.3069 191.116 23.0851 191.651 23.207C192.187 23.3289 192.395 22.5506 191.86 22.4288Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.692 20.2086C190.467 20.1573 190.221 20.294 190.165 20.5014L190.145 20.5793C190.089 20.7868 190.237 21.0133 190.463 21.0646C190.688 21.1159 190.934 20.9793 190.99 20.7717L191.01 20.6939C191.066 20.4864 190.918 20.2599 190.692 20.2086Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.784 18.6483C192.559 18.597 192.313 18.7337 192.257 18.9412L192.237 19.019C192.181 19.2265 192.329 19.4531 192.555 19.5043C192.787 19.5297 193.026 19.419 193.082 19.2114L193.102 19.1336C193.158 18.9261 193.01 18.6997 192.784 18.6483Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.76 18.7225C189.295 18.8444 189.504 18.0663 188.969 17.9443C188.433 17.8224 188.225 18.6007 188.76 18.7225Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.33 17.1611C191.865 17.283 192.074 16.5049 191.539 16.3829C190.976 16.2547 190.767 17.0328 191.33 17.1611Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.789 15.7944C193.824 15.7749 193.859 15.7553 193.894 15.7358C194.105 15.6187 194.167 15.3852 194.04 15.1911C193.906 15.0229 193.624 14.9587 193.449 15.0563C193.414 15.0759 193.379 15.0954 193.343 15.1149C193.133 15.2321 193.07 15.4655 193.197 15.6597C193.325 15.8538 193.578 15.9115 193.789 15.7944Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.197 12.9272C191.972 12.8758 191.726 13.0125 191.67 13.22C191.614 13.4276 191.763 13.654 191.988 13.7053L192.073 13.7246C192.298 13.7759 192.544 13.6392 192.599 13.4317C192.627 13.2178 192.507 12.9977 192.281 12.9464L192.197 12.9272Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.858 14.2936C189.323 14.1717 189.114 14.9499 189.649 15.0717C190.184 15.1937 190.393 14.4155 189.858 14.2936Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.197 16.3024C187.423 16.3536 187.669 16.217 187.724 16.0095L187.745 15.9317C187.801 15.7241 187.652 15.4977 187.427 15.4464C187.195 15.421 186.956 15.5317 186.9 15.7392L186.879 15.817C186.824 16.0245 186.972 16.2511 187.197 16.3024Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.247 13.6563L185.226 13.7341C185.171 13.9416 185.319 14.1681 185.545 14.2194C185.777 14.2448 186.016 14.134 186.071 13.9265L186.092 13.8487C186.148 13.6412 185.999 13.4148 185.774 13.3634C185.549 13.3121 185.303 13.4488 185.247 13.6563Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.045 12.8072C188.58 12.9291 188.789 12.1509 188.254 12.029C187.719 11.9072 187.51 12.6853 188.045 12.8072Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.788 10.6891L184.703 10.6699C184.478 10.6185 184.232 10.7552 184.177 10.9627C184.121 11.1703 184.269 11.3967 184.495 11.448L184.579 11.4673C184.805 11.5186 185.05 11.382 185.106 11.1744C185.162 10.9669 185.041 10.7468 184.788 10.6891Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.453 13.205C181.989 13.3269 182.197 12.5487 181.662 12.4268C181.127 12.3049 180.918 13.0831 181.453 13.205Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.295 14.9181L183.316 14.8403C183.372 14.6328 183.223 14.4063 182.998 14.3549C182.773 14.3036 182.527 14.4404 182.471 14.6478L182.45 14.7257C182.395 14.9331 182.543 15.1597 182.768 15.211C183.022 15.2687 183.232 15.1515 183.295 14.9181Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.981 14.5134C179.516 14.6353 179.724 13.8571 179.189 13.7352C178.626 13.6069 178.417 14.3851 178.981 14.5134Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.563 16.5252C181.098 16.6472 181.307 15.869 180.772 15.7471C180.237 15.6252 180.028 16.4034 180.563 16.5252Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.188 15.1786C176.653 15.0568 176.445 15.835 176.98 15.9568C177.515 16.0787 177.724 15.3006 177.188 15.1786Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.986 18.2228C178.521 18.3447 178.73 17.5665 178.195 17.4446C177.631 17.3163 177.423 18.0945 177.986 18.2228Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.216 16.566C173.977 16.5666 173.781 16.742 173.753 16.956C173.719 17.1958 173.888 17.3445 174.106 17.4217C174.27 17.481 174.46 17.3865 174.563 17.2586C174.487 17.3295 174.382 17.3745 174.268 17.376L174.24 17.3696C174.338 17.337 174.444 17.2783 174.542 17.2457C174.542 17.2457 174.577 17.2262 174.584 17.2003L174.633 17.0187C174.625 16.9371 174.587 16.8763 174.573 16.8179C174.571 16.8147 174.566 16.8108 174.562 16.8044C174.462 16.7541 174.391 16.6855 174.288 16.6345L174.316 16.641C174.414 16.677 174.5 16.7326 174.562 16.8044C174.565 16.805 174.568 16.8057 174.57 16.8089C174.57 16.8089 174.571 16.8147 174.574 16.8153C174.638 16.8987 174.667 17.0044 174.634 17.1263C174.622 17.1703 174.598 17.2145 174.563 17.256C174.647 17.1787 174.693 17.0737 174.676 16.9706C174.654 16.7179 174.456 16.5628 174.217 16.5634L174.216 16.566Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.253 19.7197C175.479 19.7711 175.718 19.6603 175.78 19.4269L175.801 19.3491C175.857 19.1416 175.708 18.915 175.483 18.8638C175.258 18.8125 175.012 18.9491 174.956 19.1566L174.935 19.2345C174.88 19.442 175.028 19.6684 175.253 19.7197Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.519 17.9333C171.484 17.9528 171.448 17.9724 171.413 17.9919C171.203 18.109 171.14 18.3425 171.267 18.5365C171.394 18.7307 171.648 18.7884 171.859 18.6713C171.894 18.6517 171.929 18.6323 171.964 18.6128C172.175 18.4956 172.237 18.2621 172.11 18.068C171.983 17.8738 171.729 17.8161 171.519 17.9333Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.385 20.7805L173.406 20.7027C173.462 20.4952 173.313 20.2686 173.088 20.2174C172.862 20.1661 172.624 20.2768 172.561 20.5103L172.54 20.5881C172.484 20.7956 172.633 21.022 172.858 21.0734C173.083 21.1247 173.329 20.988 173.385 20.7805Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.91 21.4279C170.685 21.3766 170.439 21.5132 170.383 21.7208L170.363 21.7985C170.307 22.0061 170.455 22.2326 170.681 22.2839C170.906 22.3352 171.152 22.1985 171.208 21.9911L171.228 21.9132C171.284 21.7056 171.136 21.4792 170.91 21.4279Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.715 19.5318C169.18 19.4099 168.971 20.1881 169.507 20.3099C170.042 20.4319 170.25 19.6537 169.715 19.5318Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.385 23.2928C174.92 23.4146 175.129 22.6364 174.593 22.5145C174.058 22.3927 173.85 23.1708 174.385 23.2928Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.326 21.0175C176.763 20.8892 176.554 21.6674 177.117 21.7958C177.681 21.9241 177.861 21.1394 177.326 21.0175Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.764 19.8388C179.229 19.7169 179.02 20.4952 179.555 20.617C180.09 20.7389 180.299 19.9607 179.764 19.8388Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.027 18.9781C182.562 19.1 182.771 18.3217 182.236 18.1999C181.701 18.078 181.492 18.8561 182.027 18.9781Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.906 16.9363L184.821 16.9171C184.596 16.8658 184.35 17.0025 184.294 17.21C184.239 17.4175 184.359 17.6376 184.612 17.6953L184.697 17.7145C184.922 17.7658 185.168 17.6292 185.224 17.4217C185.279 17.2142 185.131 16.9877 184.906 16.9363Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.835 19.6603C186.89 19.4528 186.742 19.2263 186.517 19.1749L186.432 19.1558C186.207 19.1044 185.961 19.2411 185.905 19.4485C185.85 19.6561 185.998 19.8826 186.223 19.9339L186.308 19.9532C186.533 20.0044 186.779 19.8678 186.835 19.6603Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.086 21.5691C187.861 21.5178 187.615 21.6545 187.559 21.862L187.538 21.9399C187.483 22.1473 187.631 22.3739 187.856 22.4252C188.082 22.4765 188.321 22.3658 188.383 22.1323L188.404 22.0544C188.46 21.847 188.311 21.6205 188.086 21.5691Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.871 23.9746C185.406 24.0965 185.615 23.3183 185.08 23.1965C184.544 23.0745 184.336 23.8527 184.871 23.9746Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.067 21.0666C183.841 21.0153 183.596 21.152 183.54 21.3595L183.519 21.4373C183.463 21.6448 183.612 21.8712 183.837 21.9226C184.063 21.9739 184.301 21.8632 184.364 21.6297L184.385 21.5519C184.441 21.3444 184.292 21.1179 184.067 21.0666Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.059 22.1429C181.024 22.1625 180.988 22.182 180.953 22.2015C180.743 22.3187 180.68 22.5521 180.807 22.7463C180.906 22.934 181.188 22.9981 181.399 22.881C181.434 22.8615 181.469 22.8419 181.504 22.8224C181.715 22.7053 181.777 22.4718 181.65 22.2776C181.523 22.0836 181.269 22.0258 181.059 22.1429Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.545 25.0688C183.08 25.1907 183.289 24.4125 182.754 24.2907C182.191 24.1624 181.982 24.9405 182.545 25.0688Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.323 26.6849C183.788 26.563 183.579 27.3412 184.115 27.4631C184.65 27.585 184.858 26.8068 184.323 26.6849Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.802 28.1749C181.577 28.1235 181.331 28.2602 181.275 28.4677C181.219 28.6753 181.34 28.8953 181.593 28.953L181.678 28.9723C181.903 29.0236 182.149 28.887 182.204 28.6794C182.26 28.4719 182.112 28.2455 181.886 28.1941L181.802 28.1749Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.921 29.4453C178.886 29.4649 178.851 29.4844 178.816 29.504C178.605 29.6211 178.542 29.8545 178.669 30.0487C178.804 30.2169 179.057 30.2746 179.261 30.1834C179.296 30.1639 179.331 30.1444 179.366 30.1248C179.577 30.0077 179.64 29.7742 179.512 29.5801C179.385 29.386 179.132 29.3282 178.921 29.4453Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.961 26.6821C180.496 26.804 180.705 26.0259 180.17 25.9039C179.634 25.782 179.426 26.5602 179.961 26.6821Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.816 27.1019C177.281 26.9801 177.072 27.7582 177.607 27.8801C178.143 28.002 178.351 27.2238 177.816 27.1019Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.276 24.9344C176.05 24.8831 175.804 25.0198 175.749 25.2273L175.728 25.3051C175.672 25.5126 175.821 25.7391 176.046 25.7904C176.271 25.8417 176.51 25.731 176.573 25.4975L176.594 25.4197C176.649 25.2122 176.501 24.9857 176.276 24.9344Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.537 23.4127C178.001 23.2907 177.793 24.0689 178.328 24.1908C178.863 24.3127 179.072 23.5345 178.537 23.4127Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.052 35.7032C179.489 35.5749 179.28 36.353 179.843 36.4813C180.406 36.6097 180.587 35.8251 180.052 35.7032Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.798 38.1577L180.777 38.2356C180.722 38.443 180.87 38.6695 181.095 38.7209C181.321 38.7722 181.56 38.6614 181.622 38.428L181.643 38.3501C181.699 38.1427 181.55 37.9161 181.325 37.8648C181.1 37.8135 180.854 37.9501 180.798 38.1577Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.704 40.1882C182.669 40.2077 182.634 40.2272 182.599 40.2468C182.388 40.3639 182.325 40.5974 182.453 40.7915C182.58 40.9857 182.833 41.0434 183.044 40.9262C183.079 40.9067 183.114 40.8872 183.15 40.8676C183.36 40.7505 183.423 40.5171 183.296 40.3229C183.161 40.1547 182.908 40.097 182.704 40.1882Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.38 42.7442L184.295 42.725C184.07 42.6736 183.824 42.8103 183.768 43.0178C183.713 43.2254 183.861 43.4518 184.086 43.5031L184.171 43.5224C184.396 43.5737 184.642 43.4371 184.698 43.2295C184.725 43.0156 184.605 42.7956 184.38 42.7442Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.73 44.951C185.195 44.8292 184.986 45.6074 185.522 45.7292C186.057 45.8511 186.265 45.0729 185.73 44.951Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.921 44.2211C181.386 44.0992 181.178 44.8774 181.713 44.9993C182.248 45.1212 182.457 44.343 181.921 44.2211Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.204 41.7106C179.669 41.5887 179.46 42.3668 179.995 42.4888C180.53 42.6107 180.739 41.8324 180.204 41.7106Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.846 39.5297L178.762 39.5104C178.537 39.4591 178.291 39.5958 178.235 39.8033C178.179 40.0108 178.328 40.2373 178.553 40.2886L178.638 40.3079C178.863 40.3592 179.109 40.2225 179.164 40.015C179.192 39.8011 179.072 39.581 178.846 39.5297Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.669 43.2525L177.584 43.2332C177.359 43.1819 177.113 43.3185 177.057 43.5261C177.002 43.7336 177.15 43.9601 177.375 44.0114L177.46 44.0306C177.685 44.082 177.931 43.9453 177.987 43.7378C178.014 43.5239 177.894 43.3038 177.669 43.2525Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.421 45.6333C178.886 45.5114 178.677 46.2896 179.212 46.4115C179.747 46.5334 179.956 45.7552 179.421 45.6333Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.414 44.6381L175.33 44.6189C175.104 44.5675 174.859 44.7042 174.803 44.9117C174.747 45.1193 174.896 45.3457 175.121 45.397L175.206 45.4163C175.431 45.4676 175.677 45.331 175.732 45.1234C175.788 44.9159 175.668 44.6958 175.414 44.6381Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.511 35.8091C161.976 35.6871 161.767 36.4653 162.302 36.5872C162.837 36.7091 163.046 35.9309 162.511 35.8091Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.195 33.3624C160.659 33.2405 160.451 34.0186 160.986 34.1405C161.521 34.2624 161.73 33.4842 161.195 33.3624Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.001 30.133L162.022 30.0551C162.106 29.8541 161.901 29.6147 161.704 29.5698C161.45 29.5122 161.261 29.6616 161.177 29.8627L161.156 29.9405C161.072 30.1417 161.277 30.3809 161.474 30.4259C161.735 30.4577 161.917 30.3341 162.001 30.133Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.249 28.9936C164.784 29.1155 164.993 28.3374 164.458 28.2154C163.923 28.0935 163.714 28.8718 164.249 28.9936Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.162 26.7121C166.627 26.5902 166.418 27.3683 166.953 27.4902C167.489 27.6121 167.697 26.8339 167.162 26.7121Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.346 25.3654C169.311 25.3849 169.276 25.4045 169.241 25.424C169.03 25.5411 168.967 25.7746 169.095 25.9687C169.222 26.1628 169.475 26.2206 169.686 26.1034C169.721 26.0838 169.756 26.0644 169.792 26.0449C170.002 25.9277 170.065 25.6942 169.938 25.5001C169.81 25.3059 169.557 25.2482 169.346 25.3654Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.332 24.0363C171.797 23.9144 171.589 24.6926 172.124 24.8145C172.659 24.9364 172.868 24.1582 172.332 24.0363Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.726 26.418C173.191 26.2962 172.982 27.0743 173.517 27.1962C174.052 27.3181 174.261 26.5399 173.726 26.418Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.104 28.4109C175.069 28.4304 175.034 28.45 174.999 28.4695C174.788 28.5866 174.725 28.8201 174.853 29.0141C174.98 29.2083 175.233 29.266 175.444 29.1489C175.479 29.1293 175.514 29.1098 175.549 29.0904C175.76 28.9731 175.823 28.7397 175.696 28.5456C175.568 28.3514 175.315 28.2937 175.104 28.4109Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.633 30.16C172.098 30.0381 171.889 30.8163 172.424 30.9382C172.959 31.0601 173.168 30.2818 172.633 30.16Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.275 27.9791C170.74 27.8572 170.531 28.6355 171.066 28.7573C171.601 28.8792 171.81 28.1011 171.275 27.9791Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.613 29.3269C168.049 29.1986 167.841 29.9768 168.404 30.1051C168.967 30.2334 169.148 29.4488 168.613 29.3269Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.315 30.5377C165.78 30.4157 165.572 31.194 166.107 31.3158C166.642 31.4378 166.851 30.6596 166.315 30.5377Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.801 32.0018C163.266 31.8799 163.029 32.6517 163.592 32.78C164.155 32.9082 164.336 32.1236 163.801 32.0018Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.94 33.9952C164.405 33.8733 164.196 34.6515 164.731 34.7734C165.266 34.8952 165.475 34.117 164.94 33.9952Z",
    fill: "#232457"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2708_26364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 93,
    width: 27,
    height: 42
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93.2941H25V134.765H52V93.2941Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2708_26364)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9014 103.08C51.737 102.15 51.244 100.988 49.9527 101.559C49.2718 101.855 48.7788 102.426 48.2388 102.89C47.7692 103.292 47.3231 103.123 46.7596 103.376C45.4683 103.966 44.4635 105.45 43.7145 106.671C43.6652 106.707 43.63 106.76 43.6136 106.836C43.5149 106.999 43.4187 107.159 43.3295 107.308C42.8998 108.011 42.5265 108.738 42.2049 109.482C42.611 107.248 42.9726 105.01 43.2825 102.763C43.6112 100.375 44.1747 97.7979 43.6347 95.4091C43.4938 94.7548 43.2356 93.719 42.4843 93.402C41.686 93.0638 40.8877 93.5918 40.3008 94.036C38.5164 95.4091 37.4599 97.3749 36.5208 99.277C35.3234 101.707 34.1964 104.18 33.0225 106.61C31.7782 109.209 30.5573 111.808 29.759 114.556C29.0429 117.043 28.6485 119.594 28.5593 122.153C28.7706 122.474 28.9796 122.795 29.1956 123.114C28.9843 123.178 28.7495 123.22 28.5382 123.284C28.5382 122.907 28.5452 122.529 28.5593 122.153C28.3128 121.777 28.0639 121.4 27.8103 121.022C27.6695 120.811 27.3408 120.811 27.1999 121.022C24.4295 125.122 24.2651 130.321 26.7538 134.568C26.9651 134.991 27.5756 134.652 27.3643 134.294C25.0869 130.397 25.1714 125.682 27.5098 121.851C27.4065 121.694 27.3032 121.537 27.1999 121.382H27.8103C27.707 121.536 27.6084 121.694 27.5098 121.851C27.8667 122.392 28.2189 122.933 28.5851 123.474C28.7729 123.748 29.2425 123.621 29.2425 123.304C29.266 118.486 30.4164 113.9 32.4356 109.463C33.4686 107.202 34.5721 104.94 35.6286 102.701C36.5677 100.756 37.3895 98.7065 38.6103 96.8892C39.1973 96.0008 39.9016 95.1769 40.7703 94.5005C41.2164 94.1623 41.8269 93.6766 42.4843 94.3106C42.6721 94.4793 42.766 95.0083 42.8364 95.2193C43.0477 95.8957 43.0947 96.6136 43.1182 97.3325C43.1416 99.5516 42.719 101.792 42.3903 103.968C41.686 108.787 40.7703 113.562 39.6199 118.318C38.5023 122.971 37.1547 127.574 35.6309 132.109C35.6216 132.125 35.6145 132.142 35.6051 132.159C35.5816 132.204 35.5723 132.248 35.5699 132.29C35.4173 132.74 35.267 133.191 35.1121 133.639C35.0581 133.786 35.1262 133.9 35.2412 133.966C35.1731 134.281 35.6943 134.515 35.8869 134.188C38.5188 129.391 40.2726 124.31 41.6273 119.131C44.1676 114.534 46.9663 110.055 49.9973 105.722C50.2321 105.363 49.6216 105.046 49.3869 105.405C46.8371 109.063 44.4541 112.817 42.2471 116.648C43.0102 113.451 43.6535 110.223 44.2874 107.014C45.1514 105.592 46.6164 103.495 47.9077 103.926C48.0016 103.968 48.1895 103.926 48.2599 103.842C48.5886 103.461 49.2225 102.595 49.7625 102.446C50.1851 102.467 50.5843 102.51 51.0069 102.531C51.0773 102.763 51.1477 102.996 51.1712 103.229C51.2416 103.588 51.2651 103.947 51.2651 104.306C51.2416 105.807 50.7486 107.286 50.279 108.723C49.3869 111.491 48.3538 114.217 47.2269 116.922C44.926 122.354 42.1556 127.594 38.939 132.645C38.7043 133.005 39.3147 133.322 39.5495 132.962C43.5408 126.707 46.8512 120.114 49.4338 113.288C50.0912 111.534 50.7251 109.759 51.2651 107.962C51.7582 106.399 52.2043 104.729 51.899 103.08H51.9014ZM41.5334 112.987C41.5263 113.019 41.5169 113.049 41.5099 113.08C41.5169 113.049 41.524 113.019 41.5287 112.987C41.5287 112.987 41.531 112.987 41.5334 112.987Z",
    fill: "#232457"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6084 97.0154C37.8614 108.934 31.5693 120.008 30.1606 132.181C30.1136 132.582 30.818 132.582 30.8649 132.181C32.2736 120.071 38.5658 109.019 41.2893 97.1638C41.3832 96.7832 40.7023 96.6136 40.6084 97.0154Z",
    fill: "#232457"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5837 47.259C89.6944 41.1579 90.6131 32.7641 95.9203 27.1624C101.139 21.6336 109.215 19.3881 116.935 20.1865C133.025 21.8659 143.898 34.0506 151.092 46.4059C158.619 59.3083 163.635 73.7675 174.454 84.7673C179.387 89.72 185.378 93.953 192.333 96.1095C197.377 97.6623 204.849 98.8982 207.562 93.3402C210.434 87.4178 205.915 79.8131 202.442 74.9253C198.144 68.779 192.255 63.7892 185.344 60.2205C184.468 59.7369 183.852 61.1492 184.747 61.5873C191.363 65.0464 197.006 69.9449 201.186 75.8358C204.365 80.3498 211.899 93.8904 201.842 95.8247C197.973 96.5602 193.559 95.1354 190.053 93.7291C186.449 92.2862 183.123 90.2057 180.153 87.8338C173.83 82.7891 169.1 76.3234 165.179 69.576C157.947 57.0474 152.958 43.1807 142.77 32.3089C134.341 23.3069 121.268 16.5529 108.052 19.1685C101.281 20.5217 95.0427 24.4548 91.8257 30.2493C88.6778 36.0166 89.1648 43.026 93.3571 48.2334C93.966 48.9356 95.2219 48.0251 94.5837 47.259Z",
    fill: "#FF4F79"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2708_26364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234,
    height: 141,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBannerLeft);
export default __webpack_public_path__ + "static/media/dashboardBannerLeft.6ad32353be986398fc0fa147c84ec68d.svg";
export { ForwardRef as ReactComponent };